// extracted by mini-css-extract-plugin
export default {"list":"Breadcrumb_list__zgYay","list-item":"Breadcrumb_list-item__jR8NJ","link":"Breadcrumb_link__dYXyS","arrow-divider":"Breadcrumb_arrow-divider__Mvd1m"};